const MANAGED_ATTRIBUTE = 'data-teusc-seo'
const JSON_LD_ID = 'teusc-article-jsonld'

function ensureMeta(selector, attributes) {
  let element = document.head.querySelector(selector)
  if (!element) {
    element = document.createElement('meta')
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value))
    element.setAttribute(MANAGED_ATTRIBUTE, 'true')
    document.head.appendChild(element)
  }
  return element
}

function setMeta(selector, attributes, content) {
  const element = ensureMeta(selector, attributes)
  element.setAttribute('content', content || '')
}

export function toAbsoluteUrl(value, baseUrl) {
  if (!value) return ''
  const bases = [baseUrl, window.location.origin].filter(Boolean)
  for (const base of [...new Set(bases)]) {
    try {
      return new URL(value, base).toString()
    } catch {
      // A malformed configured site URL must not suppress canonical metadata.
    }
  }
  return ''
}

export function setPageSeo({
  title,
  description = '',
  keywords = [],
  image = '',
  url = '',
  type = 'website'
}) {
  document.title = title
  setMeta('meta[name="description"]', { name: 'description' }, description)
  setMeta('meta[name="keywords"]', { name: 'keywords' }, keywords.join(','))
  setMeta('meta[property="og:type"]', { property: 'og:type' }, type)
  setMeta('meta[property="og:title"]', { property: 'og:title' }, title)
  setMeta('meta[property="og:description"]', { property: 'og:description' }, description)
  setMeta('meta[property="og:image"]', { property: 'og:image' }, image)
  setMeta('meta[property="og:url"]', { property: 'og:url' }, url)
  setMeta(
    'meta[name="twitter:card"]',
    { name: 'twitter:card' },
    image ? 'summary_large_image' : 'summary'
  )
  setMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, title)
  setMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, description)
  setMeta('meta[name="twitter:image"]', { name: 'twitter:image' }, image)

  let canonical = document.head.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    canonical.setAttribute(MANAGED_ATTRIBUTE, 'true')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', url)
}

export function setPageIndexing(indexable) {
  setMeta(
    'meta[name="robots"]',
    { name: 'robots' },
    indexable ? 'index, follow' : 'noindex, nofollow'
  )
}

export function setSiteIcon(href) {
  let icon = document.head.querySelector('link[rel="icon"]')
  if (!href) {
    icon?.remove()
    return
  }
  if (!icon) {
    icon = document.createElement('link')
    icon.setAttribute('rel', 'icon')
    document.head.appendChild(icon)
  }
  icon.setAttribute('href', href)
}

export function setArticleJsonLd(payload) {
  let script = document.getElementById(JSON_LD_ID)
  if (!script) {
    script = document.createElement('script')
    script.id = JSON_LD_ID
    script.type = 'application/ld+json'
    document.head.appendChild(script)
  }
  script.textContent = JSON.stringify(payload).replace(/</g, '\\u003c')
}

export function clearArticleJsonLd() {
  document.getElementById(JSON_LD_ID)?.remove()
}
